import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { OrganizationsTable } from '@/components/organizations/table/OrganizationsTable';
import { backendApiOrganizationsFindAllOptions } from '@/modules/api/@tanstack/react-query.gen';

export const Route = createFileRoute('/_authenticated/_management/administration/organisationen/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: OrganizationsRoute,
});

function OrganizationsRoute() {
  const { data, isFetching } = useQuery(backendApiOrganizationsFindAllOptions());

  return <OrganizationsTable data={data} isFetching={isFetching} fullHeight />;
}
